export default {
  title: {
    management: 'จัดการคลินิก',
    clinic: 'คลินิก',
    managePatient: 'จัดการคนไข้',
    edit: 'แก้ไขข้อมูลคลินิก',
    user: {
      edit: 'แก้ไขข้อมูลผู้ใช้งาน'
    }
  },
  headers: {

  },
  label: {
    name: 'ชื่อห้อง',
    clinicRoom: 'ห้องคลินิก',
    clinicId: 'รหัสคลินิก',
    clinicName: 'ชื่อคลินิก',
    clinicNameEn: 'ชื่อคลินิก (EN)',
    bed: 'เตียง',
    timer: 'ตัวจับเวลา',
    noneTimer: 'ไม่มีตัวจับเวลา',
    type: 'ประเภทห้อง',
    info: 'ข้อมูลคลินิก',
    bedQty: 'จำนวนเตียง',
    person: 'ผู้มีสิทธิใช้ห้อง',
    license: 'เลขที่ใบอนุญาติ',
    medicalLicenseNumber: 'เลขที่ใบอนุญาติประกอบโรคศิลปะ',
    vat: 'ภาษีมูลค่าเพิ่ม',
    vatType: 'ประเภท VAT',
    vatPlusProduct: 'VAT คำนวณรวมกับราคาสินค้า ',
    vatMinusProduct: 'VAT คำนวณแยกกับราคาสินค้า ',
    storeData: 'ข้อมูลร้าน',
    vatValue: 'ค่าภาษี',
    downloadList: 'รายการดาวโหลด',
    downloading: 'กำลังดาวน์โหลดข้อมูล',
    seeNews: 'ดูข้อมูลข่าวสาร',
    news: 'ข่าวสาร',
    downloadDoc: 'เอกสารที่ดาวน์โหลด',
    form: 'แบบฟอร์ม',
    newsTitle: 'หัวข้อข่าวสาร',
    recipients: 'จำนวนผู้รับ (คน)',
    newsChanal: 'ช่องทางการส่ง',
    newsDetail: 'รายละเอียดข่าวสาร',
    sendTime: 'เวลาส่ง',
    target: 'กลุ่มเป้าหมาย',
    oneByOne: 'ระบุรายคน',
    text: 'ข้อความ',
    newsSave: 'บันทึกและส่งข้อความ',
    theme: 'ธีมสี',
    color: 'สี',
    menuColor: 'สีเมนู',
    mainColor: 'สีหลัก',
    subColor: 'สีรอง',
    user: 'ผู้ใช้งาน',
    role: 'บทบาท',
    roles: {
      owner: 'เจ้าของ',
      admin: 'แอดมิน',
      doctor: 'แพทย์',
      cashier: 'แคชเชียร์',
      manager: 'ผู้จัดการ',
      stockManager: 'ผู้จัดการสต็อก',
      serviceStaff: 'พนักงานบริการ',
      reception: 'แผนกต้อนรับ'
    },
    link: 'ลิงก์ User',
    copy: 'คัดลอก !',
    sendEmail: 'ส่งอีเมลเชิญผู้ใช้งาน',
    waitConfirmation: 'รอยืนยัน',
    confirmed: 'ยืนยันแล้ว'
  },
  placeholder: {
    info: 'กรอกข้อมูลคลินิก',
    name: 'กรอกชื่อห้อง',
    clinicName: 'กรอกชื่อคลินิก',
    clinicNameEn: 'ชื่อคลินิก (EN)',
    bedQty: 'กรอกจำนวนเตียง',
    color: 'เลือกสีห้อง',
    selectColor: 'เลือกสีห้องที่ต้องการ',
    border: 'เลือกสีขอบ',
    selectBrder: 'เลือกสีขอบที่ต้องการ',
    license: 'กรอกเลขที่ใบอนุญาติ',
    medicalLicenseNumber: 'ใบอนุญาตประกอบวิชาชีพเวชกรรมเลขที่',
    medicalPracticeLocation: 'สถานที่ประกอบวิชาชีพเวชกรรม ไพรเวชคลินิกการแพทย์แผนจีนได้ตรวจร่างกาย',
    medicalPracticeLocationsec1: 'สถานที่ประกอบวิชาชีพเวชกรรม',
    vat: 'กรอกภาษีมูลค่าเพิ่ม',
    downloadDoc: 'เอกสารดาวน์โหลด',
    newsChanal: 'เลือกช่องทางการส่ง',
    newsTitle: 'กรอกหัวข้อ',
    title: 'หัวข้อ',
    searchEmailUser: 'ค้นหาอีเมล ชื่อผู้ใช้งาน',
    role: 'กรอกบทบาท'
  },
  toolTip: {

  },
  modal: {
    create: {
      success: 'สร้างห้องคลินิกสำเร็จ !',
      news: {
        title: 'สร้างข่าวสาร',
        success: 'สร้างข่าวสารสำเร็จ'
      },
      user: {
        title: '',
        subTitle: '',
        success: 'สร้างข้อมูลผู้ใช้งานสำเร็จ !'
      }
    },
    edit: {
      success: 'แก้ไขห้องคลินิกสำเร็จ !',
      news: {
        title: 'แก้ไขข้อมูลข่าวสาร',
        success: 'แก้ไขข้อมูลข่าวสารสำเร็จ !'
      },
      user: {
        title: 'ยืนยันการลบพนักงาน',
        subTitle: 'คุณกำลังลบพนักงานในคลินิกนี้ ต้องการดำเนินการต่อหรือไม่ ?',
        success: 'แก้ไขข้อมูลผู้ใช้งานสำเร็จ !'
      }
    },
    delete: {
      title: 'ยืนยันการลบห้อง',
      subtitle1: 'คุณกำลังลบห้อง',
      subtitle2: 'ต้องการดำเนินการต่อหรือไม่',
      news: {
        title: 'ยืนยันการลบข่าวสาร',
        subTitle: 'คุณกำลังลบข่าวสาร ต้องการดำเนินการต่อหรือไม่ ?',
        success: 'ลบข่าวสารสำเร็จ'
      },
      user: {
        title: 'ยืนยันการลบพนักงาน',
        subTitle: 'คุณกำลังลบพนักงานในคลินิกนี้ ต้องการดำเนินการต่อหรือไม่ ?'
      }

    }
  }

}
